<script setup>
const iconComponents = import.meta.globEager('./Icon/*.vue')

defineProps({
  name: {
    type: String,
    required: true
  }
})

const components = Object.entries(iconComponents).reduce((components, [path, component]) => {
  const componentName = path.split('/').pop().replace('.vue', '')
  components[componentName] = component.default
  return components
}, {})
</script>

<template>
  <component :is="components[name]" />
</template>
